import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { StatusBar } from 'expo-status-bar';
import { memo, useState } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { PosterStudioFailure } from './components/PosterStudioFailure';
import { PosterStudioSession } from './components/PosterStudioSession';
import { posterStudioLocation } from './functions/posterStudioLocation';

const kNotConfigured = '朋友圈海报暂未配置，请联系管理员';

/**
 * The poster studio, framed (K09 in the posters repo), full screen below the
 * status bar and signed in as this user's store. The studio draws its own bar,
 * with ‹ back here. Navigation-agnostic: leaving is the host's callback.
 */
export const PosterStudioView = memo(
  ({
    orgId,
    storeId,
    onLeave,
  }: {
    orgId: number;
    storeId: number;
    onLeave: () => void;
  }) => {
    const insets = useSafeAreaInsets();
    // A retry is a new session: a new token, a freshly loaded studio.
    const [attempt, setAttempt] = useState(0);
    const [location] = useState(posterStudioLocation);
    return (
      <View
        style={{
          flex: 1,
          paddingTop: insets.top,
          backgroundColor: aiColors.card,
        }}
      >
        <StatusBar style="dark" />
        {location ? (
          <PosterStudioSession
            key={attempt}
            location={location}
            orgId={orgId}
            storeId={storeId}
            onLeave={onLeave}
            onRetry={() => setAttempt(previous => previous + 1)}
          />
        ) : (
          <PosterStudioFailure
            message={kNotConfigured}
            actions={[{ label: '返回', onPress: onLeave, primary: true }]}
          />
        )}
      </View>
    );
  },
);
